import WeeksPhotos from './WeeksPhotosContainer';

export default WeeksPhotos;
